(function () {
  function getStoredHeaderGroupHeight() {
    if (typeof window.__landingHeaderGroupHeight === 'number' && window.__landingHeaderGroupHeight > 0) {
      return window.__landingHeaderGroupHeight;
    }
    var headerGroup = document.querySelector('.shopify-section-group-header-group');
    if (!headerGroup) return 0;
    var height = headerGroup.getBoundingClientRect().height;
    if (height > 0) {
      window.__landingHeaderGroupHeight = height;
      return height;
    }
    return 0;
  }

  function syncStickyHeaderVars(has) {
    if (!has) {
      document.documentElement.style.removeProperty('--landing-header-group-height');
      document.documentElement.style.removeProperty('--sticky-header-height');
      document.documentElement.style.removeProperty('--header-height');
      return;
    }
    var h = getStoredHeaderGroupHeight();
    if (h <= 0) return;
    var px = h.toFixed(1) + 'px';
    document.documentElement.style.setProperty('--landing-header-group-height', px);
    document.documentElement.style.setProperty('--sticky-header-height', px);
    document.documentElement.style.setProperty('--header-height', px);
  }

  function syncOverride() {
    var has = !!document.querySelector('[data-landing-page-header]');
    document.body.classList.toggle('landing-page-header-active', has);
    syncStickyHeaderVars(has);
  }

  if (window.landingPageHeaderOverrideSync) {
    window.landingPageHeaderOverrideSync();
  } else {
    window.landingPageHeaderOverrideSync = syncOverride;
  }
  if (!window.landingPageHeaderOverrideInit) {
    window.landingPageHeaderOverrideInit = true;
    document.addEventListener('DOMContentLoaded', syncOverride);
    document.addEventListener('page:loaded', syncOverride);
    document.addEventListener('shopify:section:load', syncOverride);
    document.addEventListener('shopify:section:unload', syncOverride);
  }
  syncOverride();

  // Delivery cutoff timer custom element
  if (!customElements.get('delivery-cutoff-timer')) {
    customElements.define('delivery-cutoff-timer', class extends HTMLElement {
      connectedCallback() {
        this._tick = this._tick.bind(this);
        this._tick();
        this._timer = setInterval(this._tick, 1000);
      }
      disconnectedCallback() {
        clearInterval(this._timer);
      }
      _nextCutoff(now) {
        var hour = parseInt(this.getAttribute('data-cutoff-hour'), 10) || 0;
        var minute = parseInt(this.getAttribute('data-cutoff-minute'), 10) || 0;
        var tzAttr = this.getAttribute('data-tz-offset');
        var tz = tzAttr === '' || tzAttr === null ? null : parseFloat(tzAttr);

        if (tz === null || isNaN(tz)) {
          var target = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hour, minute, 0, 0);
          if (target <= now) target.setDate(target.getDate() + 1);
          return target;
        }
        var nowUtcMs = now.getTime();
        var shifted = new Date(nowUtcMs + tz * 3600 * 1000);
        var y = shifted.getUTCFullYear();
        var m = shifted.getUTCMonth();
        var d = shifted.getUTCDate();
        var targetUtcMs = Date.UTC(y, m, d, hour, minute, 0, 0) - tz * 3600 * 1000;
        if (targetUtcMs <= nowUtcMs) targetUtcMs += 24 * 3600 * 1000;
        return new Date(targetUtcMs);
      }
      _tick() {
        var now = new Date();
        var target = this._nextCutoff(now);
        var diff = target - now;
        var windowMs = (parseFloat(this.getAttribute('data-window-hours')) || 3) * 3600 * 1000;
        if (diff <= 0 || diff > windowMs) {
          this.classList.remove('is-visible');
          return;
        }
        if (this.getAttribute('data-weekdays-only') === 'true') {
          // Use the same TZ-shifted "today" the cutoff logic uses, so the
          // weekday matches the store's clock rather than the visitor's.
          var tzAttr = this.getAttribute('data-tz-offset');
          var tz = tzAttr === '' || tzAttr === null ? null : parseFloat(tzAttr);
          var wday;
          if (tz === null || isNaN(tz)) {
            wday = now.getDay();
          } else {
            var shifted = new Date(now.getTime() + tz * 3600 * 1000);
            wday = shifted.getUTCDay();
          }
          // 0=Sun, 1=Mon … 6=Sat — allow only Mon–Thu (1–4)
          if (wday < 1 || wday > 4) {
            this.classList.remove('is-visible');
            return;
          }
        }
        this.classList.add('is-visible');
        var totalSec = Math.floor(diff / 1000);
        var h = Math.floor(totalSec / 3600);
        var m = Math.floor((totalSec % 3600) / 60);
        var s = totalSec % 60;
        var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
        var hEl = this.querySelector('[data-h]');
        var mEl = this.querySelector('[data-m]');
        var sEl = this.querySelector('[data-s]');
        if (hEl) hEl.textContent = pad(h);
        if (mEl) mEl.textContent = pad(m);
        if (sEl) sEl.textContent = pad(s);
      }
    });
  }

  // Sticky behavior — per-section
  function initSticky(root) {
    if (!root || root.dataset.lph2StickyInit === 'true') return;
    root.dataset.lph2StickyInit = 'true';

    var sectionId = root.getAttribute('data-lph2-section-id') || '';
    if (!sectionId) return;

    var desktopSticky = document.querySelector('[data-lph2-sticky-desktop][data-lph2-section-id="' + sectionId + '"]');
    var mobileSticky = document.querySelector('[data-lph2-sticky-mobile][data-lph2-section-id="' + sectionId + '"]');
    if (!desktopSticky && !mobileSticky) return;

    var stopId = (mobileSticky ? (mobileSticky.getAttribute('data-lph2-stop-id') || '') : '').replace(/^#/, '').trim();
    var resumeId = ((mobileSticky ? mobileSticky.getAttribute('data-lph2-resume-id') : (desktopSticky ? desktopSticky.getAttribute('data-lph2-resume-id') : '')) || '').replace(/^#/, '').trim();
    var ticking = false;

    var stopEl = stopId ? document.getElementById(stopId) : null;
    var resumeEl = resumeId ? document.getElementById(resumeId) : null;

    function pastTop(el) {
      if (!el) return false;
      // Read phase only — caller batches all reads together before any DOM writes.
      return window.scrollY >= (el.getBoundingClientRect().top + window.scrollY);
    }

    function req() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        // --- Read phase: all DOM measurements together ---
        var scrollY = window.scrollY;
        var winW = window.innerWidth;
        var sectionBottomY = root.getBoundingClientRect().bottom + scrollY;
        var stopReached = pastTop(stopEl);
        var resumeReached = pastTop(resumeEl);
        var hideFlag = stopReached && (!resumeId || !resumeReached);
        var showBase = scrollY > sectionBottomY;
        // --- Write phase: only class mutations, no reads ---
        if (desktopSticky) desktopSticky.classList.toggle('is-active', showBase && winW >= 1000 && !hideFlag);
        if (mobileSticky) mobileSticky.classList.toggle('is-active', showBase && winW < 1000 && !hideFlag);
        ticking = false;
      });
    }
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', req, { passive: true });
    document.addEventListener('page:loaded', req);
    document.addEventListener('shopify:section:load', req);
    document.addEventListener('shopify:section:unload', req);
    req();
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-landing-page-header][data-lph2-section-id]');
    for (var i = 0; i < roots.length; i++) initSticky(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
